/* eslint-disable no-console */

import {register} from 'register-service-worker'

register('/firebase-messaging-sw.js', {
    ready() {
    },
    registered() {
        // Service worker has been registered.
    },
    cached() {
        // Content has been cached for offline use.
    },
    updatefound() {
        // New content is downloading.
    },
    updated() {
        // New content is available; please refresh.
    },
    offline() {
        // No internet connection found. App is running in offline mode.
    },
    error(error) {
        // Error during service worker registration: error
    }
})
